import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import {
  Btn,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomPanel,
  OutlinedBtnPrimary,
  PageHeader,
  ThreeDots,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import { tableCellCentered } from '../../../../assets/js/styles'
import * as VeiculoHttp from '../../../../services/api/https/registration/veiculo.http'
import { urlTagVeiculos } from '../../../../services/api/routes/registration.routes'
import { openReportInNewTab } from '../../../../services/util/report.service'
import VeiculoModal, { CARROCERIAS, RODADOS } from './VeiculoModal'
import { gerarArquivoExcelMultiSheet } from '../../../../services/util/excel.service'

const LOAD_MESSAGE = {
  NONE: 'NONE',
  INIT: 'Adquirindo informações iniciais',
  BUILD: 'Formatando dados',
  SAVE: 'Salvando veiculo',
  SUCCESS: 'Veiculo salvo com sucesso',
}

const INITIAL_STATE = {
  selecionarTodos: false,
  veiculos: [],
  modal: { show: false, data: null },
  veiculoSelecionado: null,
  globalFilter: '',
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

const Veiculo = ({ history, dispatch, selectedTp }) => {
  const [state, setState] = useState({ ...INITIAL_STATE })

  // Events
  const onBtnNovo = selectedTp => {
    if (selectedTp) setState(prevState => ({ ...prevState, modal: { show: true, data: null } }))
    else setState(prevState => ({ ...prevState, errorMessage: 'Selecione um operador logístico' }))
  }

  const onModalClose = () => {
    setState(prevState => ({ ...prevState, modal: { show: false, data: null } }))
  }

  const onModalSave = async veiculo => {
    setState(prevState => {
      const index = prevState.veiculos.findIndex(v => v.id === veiculo.id)
      if (index !== -1) {
        prevState.veiculos[index] = veiculo
      } else {
        prevState.veiculos.unshift(veiculo)
      }
      return { ...prevState, modal: { show: false, data: null } }
    })
  }

  const onMenuItemClick = (menuItem, veiculo) => {
    if (menuItem === 'Editar') {
      setState(prevState => ({ ...prevState, modal: { show: true, data: veiculo } }))
    } else if (menuItem === 'Gerar Local Movim.') {
      setState(prevState => ({ ...prevState, veiculoSelecionado: veiculo }))
    }
  }

  const onSelecionarTodosClick = () => {
    setState(prevState => {
      prevState.selecionarTodos = !prevState.selecionarTodos
      prevState.veiculos.forEach(v => (v.selected = prevState.selecionarTodos))
      return { ...prevState }
    })
  }

  const onItemClick = veiculo => {
    setState(prevState => {
      const index = prevState.veiculos.findIndex(v => v.id === veiculo.id)
      if (index !== -1) {
        const _veiculos = [...prevState.veiculos]
        _veiculos[index].selected = _veiculos[index].selected !== true
        prevState.veiculos = [..._veiculos]
      }
      return { ...prevState }
    })
  }

  const onBtnGerarTagVeiculosClick = veiculos => {
    const veiculosSelecionados = veiculos.filter(v => v.selected)
    if (veiculosSelecionados.length === 0) {
      setState(prevState => ({ ...prevState, errorMessage: 'Não existe veículo selecionado' }))
    } else {
      const ids = veiculosSelecionados.map(v => v.id).join(',')
      const url = urlTagVeiculos(ids)
      openReportInNewTab(url)
    }
  }

  const onChangeGlobalFilter = value => {
    setState(prevState => ({ ...prevState, globalFilter: value }))
  }

  const onBtnExportarExcelClick = veiculos => {
    const colunas = [
      [
        'nome (string)*',
        'placa (string)*',
        'ano_fabricacao (int)',
        'modelo (string)*',
        'capacidade_kg (int)*',
        'capacidade_m3 (int)',
        'cnh_motorista_padrao (int)*',
        'km_inicial (int)',
        'proprio (0,1)*',
        'transportadora_cnpj (string)',
        'ativo (0,1)*',
        'tipo_carroceria (int)',
        'tipo_rodado (int)',
      ],
    ]

    veiculos.forEach(v => {
      colunas.push([
        v.nickname,
        v.vehicle_badge,
        v.year,
        v.manufacturer,
        v.capacity_kg,
        v.capacity_m3,
        v.default_driver_cnh,
        v.initial_km,
        v.category === 'Proprio' ? 1 : 0,
        v.transportadora_cnpj,
        v.actived ? 1 : 0,
        v.tipo_carroceria,
        v.tipo_rodado,
      ])
    })
    const valoresCarrocerias = [
      ['Valor', 'Descrição'],
      ...CARROCERIAS.map(carroceria => [carroceria.value, carroceria.label]),
    ]
    const valoresRodados = [
      ['Valor', 'Descrição'],
      ...RODADOS.map(rodado => [rodado.value, rodado.label]),
    ]

    const sheets = [
      { wsName: 'Veículos', data: colunas },
      { wsName: 'Carrocerias', data: valoresCarrocerias },
      { wsName: 'Rodados', data: valoresRodados },
    ]
    gerarArquivoExcelMultiSheet(sheets, 'veiculos.xlsx')
  }

  // Helpers
  const getVeiculos = selectedTp => {
    if (selectedTp === 0) setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
    else
      VeiculoHttp.getVeiculos(selectedTp)
        .then(fetchedVeiculos => {
          setState(prevState => ({
            ...prevState,
            veiculos: fetchedVeiculos,
            loadingMessage: LOAD_MESSAGE.NONE,
          }))
        })
        .catch(err =>
          setState(prevState => ({
            ...prevState,
            errorMessage: errorHandler(err),
            loadingMessage: LOAD_MESSAGE.NONE,
          })),
        )
  }

  const initialFetch = () => {
    setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.INIT }))
  }

  // Hooks
  useEffect(() => {
    initialFetch()
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.INIT:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        getVeiculos(selectedTp)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      setState(prevState => ({
        ...prevState,
        loadingMessage: LOAD_MESSAGE.NONE,
        errorMessage: null,
      }))
    }
  }, [state.errorMessage])

  const header = (
    <CustomDataTableHeader onChange={onChangeGlobalFilter}>
      <div style={{ paddingLeft: '4px', display: 'inline' }}>
        <Btn onClick={() => onBtnExportarExcelClick(state.veiculos)}>Exportar</Btn>
      </div>
    </CustomDataTableHeader>
  )

  return (
    <div>
      <PageHeader>2.5 - Cadastro de Veículos</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={() => onBtnNovo(selectedTp)} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-12">
              <CustomCheckbox checked={state.selecionarTodos} onChange={onSelecionarTodosClick}>
                Selecionar Todos
              </CustomCheckbox>
              <div style={{ display: 'inline-block', marginLeft: 10 }}>
                <OutlinedBtnPrimary
                  label={'Gerar os TAG dos Veículos'}
                  onClick={() => onBtnGerarTagVeiculosClick(state.veiculos)}
                />
              </div>
            </div>
            <div className="p-col-12">
              <DataTable
                value={state.veiculos}
                header={header}
                emptyMessage={'Não existe veículos cadastrados . . .'}
                globalFilter={state.globalFilter}
                paginator={true}
                rows={10}
              >
                <Column
                  header="#"
                  style={tableCellCentered(80)}
                  body={veiculo => (
                    <CustomCheckbox
                      checked={veiculo.selected === true}
                      onChange={() => onItemClick(veiculo)}
                    />
                  )}
                />

                <Column field="id" header="Código" style={tableCellCentered(80)} />
                <Column field="nickname" header="Descrição" />
                <Column field="vehicle_badge" header="Placa" style={tableCellCentered(130)} />
                <Column field="year" header="Ano" style={tableCellCentered(150)} />
                <Column
                  field="capacity_kg"
                  header="Capacidade - KG"
                  style={tableCellCentered(150)}
                />
                <Column
                  field="capacity_m3"
                  header="Capacidade - M³"
                  style={tableCellCentered(150)}
                />
                <Column
                  field="category"
                  header="Tipo"
                  style={tableCellCentered()}
                  body={veiculo =>
                    veiculo.category && veiculo.category === 'Proprio' ? (
                      <span>Próprio</span>
                    ) : (
                      <span>Terceiro</span>
                    )
                  }
                />
                <Column
                  field="actived"
                  header="Ativo"
                  style={tableCellCentered(80)}
                  body={veiculo => <CustomCheckbox onChange={() => {}} checked={veiculo.actived} />}
                />
                <Column
                  header="Menu"
                  style={tableCellCentered(80)}
                  body={veiculo => (
                    <ThreeDots
                      items={['Editar']}
                      onClick={menuItem => onMenuItemClick(menuItem, veiculo)}
                    />
                  )}
                />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
      <VeiculoModal
        show={state.modal.show}
        onModalClose={onModalClose}
        onModalSave={onModalSave}
        data={state.modal.data}
      />
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(Veiculo))
